import { render, staticRenderFns } from "./AtomRouterButton.vue?vue&type=template&id=b3e993ea&scoped=true"
import script from "./AtomRouterButton.vue?vue&type=script&lang=ts"
export * from "./AtomRouterButton.vue?vue&type=script&lang=ts"
import style0 from "./AtomRouterButton.vue?vue&type=style&index=0&id=b3e993ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e993ea",
  null
  
)

export default component.exports